import React, {Component} from "react";
import ReactModal from "react-modal";
import Input from "../../common/input";
import {dateToString, stringToDate} from "../../../services/dateTimeFormat";
import SelectByMap from "../../common/selectByMap";
import TimeKeeper from "../../common.old/timeKeeper";

class MobileWorkPeriodDataForm extends Component {
    constructor(props) {
        super();
        this.data = {...props.data};
    }

    data = {}

    render = () => {
        const {
            showModal, style, handleSave, handleDelete, handleCloseModal,
            handleChangeStartDate, handleChangeEndDate,
            handleChangeProject, handleChangeOrder, handleChangeOrderItem,
            handleChangeCostUnit, handleChangeMachine, handleChangeWorkplace, handleChangeWorkprocess,
            handleChangeComment,
            projectsMap, ordersMap, orderItemsMap, costUnitsMap, machinesMap, workplacesMap, workprocessesMap
        } = this.props;
        const {
            startDate, endDate,
            projectDbId, orderDbId, orderItemDbId, costUnitDbId, machineDbId, workplaceDbId, workprocessDbId,
            comment
        } = this.props.data;

        const projectList = projectsMap ? Object.entries(projectsMap) : []
        const orderList = ordersMap ? Object.entries(ordersMap) : []
        const orderItemList = orderItemsMap ? Object.entries(orderItemsMap) : []
        const costUnitList = costUnitsMap ? Object.entries(costUnitsMap) : []
        const machineList = machinesMap ? Object.entries(machinesMap) : []
        const workplaceList = workplacesMap ? Object.entries(workplacesMap) : []
        const workprocessList = workprocessesMap ? Object.entries(workprocessesMap) : []

        return (
            <ReactModal
                isOpen={showModal}
                contentLabel="MobileWorkPeriodDataForm"
                style={style}
                ariaHideApp={false}
            >
                <table className="table">
                    <tbody>
                    <tr>
                        <td><TimeKeeper
                            name={"start"}
                            label={"von"}
                            value={dateToString(stringToDate(startDate, "YYYYMMDDHHmm"), "HH:mm")}
                            onSimpleChange={handleChangeStartDate}
                        /></td>
                    </tr>
                    <tr>
                        <td><TimeKeeper
                            name={"end"}
                            label={"bis"}
                            value={dateToString(stringToDate(endDate, "YYYYMMDDHHmm"), "HH:mm")}
                            onSimpleChange={handleChangeEndDate}
                        /></td>
                    </tr>
                    {projectList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={projectDbId}
                                    value={projectDbId}
                                    label={"Project"}
                                    itemsMap={projectsMap}
                                    itemList={projectList}
                                    handleItemSelect={handleChangeProject}
                                />
                            </td>
                        </tr>
                    )}
                    {orderList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={orderDbId}
                                    value={orderDbId}
                                    label={"Auftrag"}
                                    itemsMap={ordersMap}
                                    itemList={orderList}
                                    handleItemSelect={handleChangeOrder}
                                />
                            </td>
                        </tr>
                    )}
                    {orderItemList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={orderItemDbId}
                                    value={orderItemDbId}
                                    label={"Auftragspos."}
                                    itemsMap={orderItemsMap}
                                    itemList={orderItemList}
                                    handleItemSelect={handleChangeOrderItem}
                                />
                            </td>
                        </tr>
                    )}
                    {costUnitList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={costUnitDbId}
                                    value={costUnitDbId}
                                    label={"Kostenstelle"}
                                    itemsMap={costUnitsMap}
                                    itemList={costUnitList}
                                    handleItemSelect={handleChangeCostUnit}
                                    error={[]}
                                    help={null}
                                    autoFocus={null}
                                />
                            </td>
                        </tr>
                    )}
                    {machineList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={machineDbId}
                                    value={machineDbId}
                                    label={"Maschine"}
                                    itemsMap={machinesMap}
                                    itemList={machineList}
                                    handleItemSelect={handleChangeMachine}
                                />
                            </td>
                        </tr>
                    )}
                    {workplaceList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={workplaceDbId}
                                    value={workplaceDbId}
                                    label={"Arbeitsplatz"}
                                    itemsMap={workplacesMap}
                                    itemList={workplaceList}
                                    handleItemSelect={handleChangeWorkplace}
                                />
                            </td>
                        </tr>
                    )}
                    {workprocessList.length > 0 && (
                        <tr>
                            <td>
                                <SelectByMap
                                    name={workprocessDbId}
                                    value={workprocessDbId}
                                    label={"Arbeitsgang"}
                                    itemsMap={workprocessesMap}
                                    itemList={workprocessList}
                                    handleItemSelect={handleChangeWorkprocess}
                                />
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td>
                            <Input
                                name={"comment"}
                                label={"Kommentar"}
                                value={comment}
                                onChange={handleChangeComment}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button onClick={handleSave}>speichern</button>
                            <button onClick={handleDelete}>löschen</button>
                            <button onClick={handleCloseModal}>abbrechen</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </ReactModal>
        );
    }
}

export default MobileWorkPeriodDataForm;
